import * as R from 'ramda';

// Debounce function with TypeScript type annotations
export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  delay: number,
) => {
  let timerId: NodeJS.Timeout | undefined;

  return (...args: Parameters<T>) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => func(...args), delay);
  };
};

// Function to check if a value is nil (null or undefined) or empty using Ramda's isNil and isEmpty
export const isNilOrEmpty = (value: any): boolean =>
  R.isNil(value) || R.isEmpty(value);
